export const TaskDetailTaxReturn = ({ label, children }) => {
  return (
    <div className="task-detail row w-100 py-1">
      <div className="task-detail-label fw-600 col-4 fs-14">{label}</div>
      <div className="task-detail-value col-8">{children}</div>
    </div>
  );
};
